import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  BoxControllerPageStyled,
  BoxPaginationStyled,
  ChevronLeftStyled,
  ChevronRightStyled,
} from './jtable.pagination.styled';
import { IconButton, Typography } from '@mui/material';
import { IMeta } from '@models/paginated-reponse';

interface IProps {
  meta: IMeta;
  onPageChange: (_: number) => void;
}

export const JTablePagination: React.FC<IProps> = ({ meta, onPageChange }) => {
  const { t } = useTranslation();
  const { itemCount, hasNextPage, hasPreviousPage, page, take } = meta;

  const startItem = itemCount !== 0 ? (Number(page) - 1) * Number(take) + 1 : 0;
  const endItem = Math.min(startItem + Number(take) - 1, itemCount);

  return (
    <BoxPaginationStyled>
      <Typography variant="body2">
        {`${startItem} - ${endItem} ${t('OF')} ${itemCount}`}
      </Typography>
      <BoxControllerPageStyled>
        <IconButton
          data-qa="previous-page-button"
          onClick={() => onPageChange(Number(page) - 1)}
          aria-label="nav-prev-page"
          disabled={!hasPreviousPage}
        >
          <ChevronLeftStyled attrs={{ active: hasPreviousPage }} />
        </IconButton>
        <IconButton
          data-qa="next-page-button"
          onClick={() => onPageChange(Number(page) + 1)}
          aria-label="nav-next-page"
          disabled={!hasNextPage}
        >
          <ChevronRightStyled attrs={{ active: hasNextPage }} />
        </IconButton>
      </BoxControllerPageStyled>
    </BoxPaginationStyled>
  );
};
